import { isDefined } from "@ls/js-utils";
import CalcType from 'state/Constants/CalcType';
import SummaryType from "state/selections/Constants/SummaryType";

export const splitByCalcType = (definitions) => {
  const abs = [],
    bmk = [],
    rel = [];
  definitions?.forEach((definition) => {
    switch (definition.summary) {
      case SummaryType.ABSOLUTE:
        abs.push(definition);
        break;
      case SummaryType.RELATIVE:
        rel.push(definition);
        break;
      case SummaryType.BENCHMARK:
        bmk.push(definition);
        break;
      default:
        throw new Error(
          `Unknown summary ${JSON.stringify(definition.summary)}`
        );
    }
  });
  return [abs, rel, bmk];
};

export const splitByCalcTypeScenario = (definitions) => {
  const abs = [], bmk = [], rel = [];
  definitions.forEach(definition => {
    switch (definition.calcType) {
      case CalcType.Account:
        abs.push(definition);
        break;
      case CalcType.Benchmark:
        bmk.push(definition);
        break;
      case CalcType.Relative:
        rel.push(definition);
        break;
      default:
        throw new Error(`Unknown calcType ${JSON.stringify(definition.calcType)}`);
    }
  });
  return [abs, bmk, rel];
};


export const getEntitySummariesObject = (node, entityId, isRelative) => {
  if (isDefined(node?.securityId)) {
    const entityResultMetaData =
      node?.positionSummary?.entityResultMetaData ?? {};
    if (
      entityResultMetaData.entityId === entityId &&
      entityResultMetaData.relative === isRelative
    ) {
      return node.positionSummary;
    }
  } else {
    return node?.entitySummaries?.find(({ entityResultMetaData = {} }) =>
      entityResultMetaData.entityId === entityId && entityResultMetaData.relative === isRelative,
    );
  }
};

export const collectEntitySummaryInfo = (entitySummaries = []) => {
  const entitySummaryMap = new Map();
  const bmkEntityIdSet = new Set();
  const bmkSummaryMap = new Map();
  entitySummaries.forEach((entitySummary) => {
    const { entityId, benchId } = entitySummary.entityResultMetaData;
    entitySummaryMap.set(entityId, entitySummary);
    if (!benchId) {
      bmkSummaryMap.set(benchId, entitySummary);
      bmkEntityIdSet.add(benchId);
    }
  });

  return { entitySummaryMap, bmkEntityIdSet, bmkSummaryMap };
};
